import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-general-settings',
  templateUrl: './general-settings.component.html',
  styleUrls: ['./general-settings.component.css']
})
export class GeneralSettingsComponent implements OnInit {
isFormChecked:boolean=false;
isUpdateChecked:boolean= false;
isAutoChecked:boolean= true;
isAllowChecked:boolean=false;
isCancellationChecked:boolean=true;
  constructor(private commonService:CommonService) { }

  ngOnInit(): void {
    const allowSwitchcheckbox = document.getElementById("allowSwitchInput") as HTMLInputElement;
    const updateSwitchcheckbox = document.getElementById("updateSwitchInput") as HTMLInputElement;
    const autoSwitchcheckbox = document.getElementById("autoSwitchInput") as HTMLInputElement;
    const formswitchcheckbox = document.getElementById("formswitchInput") as HTMLInputElement;
    const cancellationSwitchcheckbox = document.getElementById("cancellationSwitchInput") as HTMLInputElement;
    allowSwitchcheckbox.addEventListener('change',()=>{
      if (allowSwitchcheckbox.checked) {
        console.log("allow switch is ON");
        // Perform actions when switch is ON
    } else {
        console.log("allow switch is OFF");
        // Perform actions when switch is OFF
    }
    });
    updateSwitchcheckbox.addEventListener('change', () => {
      if (updateSwitchcheckbox.checked) {
          console.log("update switch is ON");
          // Perform actions when switch is ON
      } else {
          console.log("update switch is OFF");
          // Perform actions when switch is OFF
      }
    });
    autoSwitchcheckbox.addEventListener('change',()=>{
      if (autoSwitchcheckbox.checked) {
        console.log(" auto witch is ON");
        // Perform actions when switch is ON
    } else {
        console.log(" auto switch is OFF");
        // Perform actions when switch is OFF
    }
    });
    formswitchcheckbox.addEventListener('change',()=>{
      if (formswitchcheckbox.checked) {
        console.log(" forms Switch is ON");
        // Perform actions when switch is ON
    } else {
        console.log(" forms Switch is OFF");
        // Perform actions when switch is OFF
    }
    });
    cancellationSwitchcheckbox.addEventListener('change',()=>{
      if (cancellationSwitchcheckbox.checked) {
        console.log("cancellation Switch is ON");
        // Perform actions when switch is ON
    } else {
        console.log("cancellation Switch is OFF");
        // Perform actions when switch is OFF
    }
    });
  }
  onsubmit(){}
  
  }


